import { render } from "./App.vue?vue&type=template&id=5f7578b8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5f7578b8&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__